// Editores de rich-text (ex: comentário do CRM, descrição de tarefa) às
// vezes salvam linhas em branco sobrando no início/fim de um bloco de
// código ``` — o `<pre>` renderiza exatamente o que tem, então a caixa
// cresce vazia por baixo do texto real. Aparado aqui, na renderização (não
// no dado salvo), via `postrender` do vue-markdown — corrige inclusive
// comentários já salvos com o problema, sem precisar migrar dado.
const RX_PRE_CODE = /(<pre[^>]*>\s*<code[^>]*>)([\s\S]*?)(<\/code>\s*<\/pre>)/g
const RX_LEADING_BLANK_LINES = /^(?:[ \t]*\n)+/
const RX_TRAILING_BLANK_LINES = /(?:\n[ \t]*)+$/

/**
 * @param {string} html HTML já renderizado pelo vue-markdown (postrender)
 * @returns {string} mesmo HTML, com linhas em branco do início/fim de cada
 *   bloco `<pre><code>` removidas — linhas em branco NO MEIO do código
 *   (que podem ser intencionais) ficam intactas.
 */
export function trimMarkdownCodeBlocks(html) {
  if (!html) return html
  return html.replaceAll(RX_PRE_CODE, (match, open, content, close) => {
    const trimmed = content
      .replace(RX_LEADING_BLANK_LINES, '')
      .replace(RX_TRAILING_BLANK_LINES, '')
    return open + trimmed + close
  })
}
